import Swal from 'sweetalert2';

// Shown after a successful appraisal submission (approve/reject/return/recommend)
// on the commissioner/dob/ps/group-head update pages. Lets the user jump
// straight to the pending queue instead of navigating there manually.
export const promptViewPendingAppraisals = async (router, mdaId, mdaName) => {
  const result = await Swal.fire({
    title: 'View Pending Appraisals?',
    text: `Would you like to view all pending appraisals, or only pending appraisals for ${mdaName || 'this MDA'}?`,
    icon: 'question',
    showDenyButton: true,
    confirmButtonText: 'This MDA',
    denyButtonText: 'All MDAs',
    confirmButtonColor: '#2c3e50',
    denyButtonColor: '#34495e',
    customClass: {
      actions: 'appraisal-redirect-actions',
    },
  });

  if (result.isConfirmed) {
    router.push({ name: 'ViewAppraisals', query: { mdaid: mdaId, status: 'pending' } });
  } else if (result.isDenied) {
    router.push({ name: 'ViewAppraisals', query: { status: 'pending' } });
  }
};
